import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

class MyTemplates extends React.Component {

	handleTemplateChange = (event) => {
		console.log(event.target.value);
		this.props.onChangeTemplate(event.target.value);
	}

	render() {
		return (
			<div style={{marginLeft:50}}>

				<FormControl component="fieldset"  style={{ marginBottom: 10, marginTop: 60, width:400 }}>
					<RadioGroup
						aria-label="gender"
						name="gender1"
						value={this.props.template}
						onChange={this.handleTemplateChange}
					>
						<FormControlLabel style={{ width:'100%' }} value="singleRouteMap" control={<Radio />} label="Single route map (Select it for famous Races)" />
						<FormControlLabel value="multiRoutesMap" control={<Radio />} label="Multi-routes map" />
						<FormControlLabel value="calendar" control={<Radio />} label="Calendar" />
						<FormControlLabel value="gridMap" control={<Radio />} label="Grid map" />
						<FormControlLabel value="complete" control={<Radio />} label="Detailed activity" />
					</RadioGroup>
				</FormControl>
			</div>
		)
	}
}

export default MyTemplates;


// WEBPACK FOOTER //
// ./src/components/MyTemplates.js